/* This file is autogenerated, see readme.md for instructions */
import MultiParentRejectedSvgIcon from '@bloomreach/banana-theme/icons/multi-parent-rejected.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MultiParentRejectedIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MultiParentRejectedSvgIcon />
    </Icon>
  );
});

MultiParentRejectedIcon.displayName = 'MultiParentRejectedIcon';

export default MultiParentRejectedIcon;
